var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.701,
    height: 104.885,
    viewBox: "0 0 84.701 104.885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63395",
    "data-name": "Group 63395",
    transform: "translate(15488.339 3391.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-15488.339 -3393.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_410627320",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221898",
    "data-name": "Path 221898",
    d: "M143.078,161.534a23.942,23.942,0,0,0,.713-6.115,28.828,28.828,0,0,0-16.716-26.194,11.435,11.435,0,0,1-6.625-9.173v-3.567a11.586,11.586,0,0,1,6.625-9.173,28.828,28.828,0,0,0,16.716-26.194A23.942,23.942,0,0,0,143.078,75H86.713A23.942,23.942,0,0,0,86,81.115a29.068,29.068,0,0,0,16.308,26.093,11.223,11.223,0,0,1,6.523,9.275v3.567a11.377,11.377,0,0,1-6.523,9.377A28.915,28.915,0,0,0,86,155.418a23.942,23.942,0,0,0,.713,6.115Z",
    transform: "translate(-78.05 -68.171)",
    fill: "#ededed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221900",
    "data-name": "Path 221900",
    d: "M205.095,231.92a21.278,21.278,0,0,0-12.129-17.531,18.756,18.756,0,0,1-9.071-8.664,19.193,19.193,0,0,1-8.969,8.765A21.392,21.392,0,0,0,163,231.92Zm-21.2-44.745a18.513,18.513,0,0,1,9.071-8.765,21.761,21.761,0,0,0,7.746-6.115c-12.842.51-25.583-.713-37.61-10.294a21.131,21.131,0,0,0,11.823,16.308A18.938,18.938,0,0,1,183.894,187.175Z",
    transform: "translate(-147.202 -146.304)",
    fill: "#c4c4c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221902",
    "data-name": "Path 221902",
    d: "M360,401.359c0-.755.64-1.359,1.707-1.359a1.62,1.62,0,0,1,1.707,1.359v27.489c0,.6-.854,1.208-1.707,1.208-1.067,0-1.707-.6-1.707-1.208Z",
    transform: "translate(-325.014 -365.197)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30621",
    "data-name": "Rectangle 30621",
    width: 72.846,
    height: 5,
    rx: 2.5,
    transform: "translate(0 2)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30622",
    "data-name": "Rectangle 30622",
    width: 72.846,
    height: 5,
    rx: 2.5,
    transform: "translate(0 93.362)",
    fill: "#9b9b9b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63394",
    "data-name": "Group 63394",
    transform: "translate(-15440.165 -3323.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63392",
    "data-name": "Group 63392",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1743",
    "data-name": "Ellipse 1743",
    cx: 18.264,
    cy: 18.264,
    r: 18.264,
    transform: "translate(0 0)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1744",
    "data-name": "Ellipse 1744",
    cx: 15.454,
    cy: 15.454,
    r: 15.454,
    transform: "translate(2.81 2.81)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1745",
    "data-name": "Ellipse 1745",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(13.264 13.264)",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63393",
    "data-name": "Group 63393",
    transform: "translate(6.438 6.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221903",
    "data-name": "Path 221903",
    d: "M62.809,27.325a.559.559,0,0,1-.559-.559v-.958a.559.559,0,1,1,1.117,0v.958A.559.559,0,0,1,62.809,27.325Z",
    transform: "translate(-50.44 -25.25)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221904",
    "data-name": "Path 221904",
    d: "M62.809,98.325a.559.559,0,0,1-.559-.559v-.958a.559.559,0,1,1,1.117,0v.958A.559.559,0,0,1,62.809,98.325Z",
    transform: "translate(-50.44 -73.588)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221905",
    "data-name": "Path 221905",
    d: "M97.766,63.367h-.958a.559.559,0,1,1,0-1.117h.958a.559.559,0,0,1,0,1.117Z",
    transform: "translate(-73.588 -50.44)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221906",
    "data-name": "Path 221906",
    d: "M26.766,63.367h-.958a.559.559,0,1,1,0-1.117h.958a.559.559,0,1,1,0,1.117Z",
    transform: "translate(-25.25 -50.44)",
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_221907",
    "data-name": "Path 221907",
    d: "M49.81,52.853a.559.559,0,0,1-.483-.838L53.4,44.958V36.809a.559.559,0,0,1,1.117,0v8.3a.56.56,0,0,1-.075.279l-4.149,7.187A.559.559,0,0,1,49.81,52.853Z",
    transform: "translate(-35.03 -26.125)",
    fill: "#9b9b9b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoonIcon);
export default __webpack_public_path__ + "static/media/comingSoonIcon.0df60cb1ca162fa85180ba714d88d979.svg";
export { ForwardRef as ReactComponent };